// src/js/components/Shared/ImportWizard/components/RegExpRule.jsx
import React, { useState, useCallback } from "react";
import {
  ListItem,
  ListItemText,
  Grid,
  TextField,
  IconButton
} from "@material-ui/core";
import LabeledAutocomplete from "js/components/Shared/Form/Fields/LabeledAutocomplete";
import DeleteIcon from "@material-ui/icons/Delete";

export default React.memo(function RegExpRule({
  suggestions,
  onRemove,
  id,
  estado,
  onUpdate
}) {
  /* ---------- 1️⃣  Estados locales -------------------------------- */
  const [entrada, setEntrada] = useState((estado && estado.entrada) || null);
  const [salida, setSalida] = useState((estado && estado.salida) || null);

  /* ---------- 2️⃣  Cambios – actualiza el estado externo ------------ */
  const handleEntradaChange = useCallback(
    e => {
      const nv = e.target.value;
      setEntrada(nv);
      const newEstado = {
        ...estado,
        entrada: nv,
        salida // mantiene el valor actual de salida
      };
      onUpdate(newEstado, id);
    },
    [estado, id, onUpdate]
  );

  const handleSalidaChange = useCallback(
    value => {
      setSalida(value);
      const newEstado = {
        ...estado,
        entrada, // mantiene el valor actual de entrada
        salida: value
      };
      onUpdate(newEstado, id);
    },
    [estado, entrada, id, onUpdate]
  );

  const handleSalidaInputChange = useCallback(
    e => handleSalidaChange(e.target.value),
    [handleSalidaChange]
  );

  /* ---------- 3️⃣  Eliminación --------------------------------------- */
  const handleRemove = useCallback(() => onRemove(id), [onRemove, id]);

  /* ---------- 4️⃣  Render ------------------------------------------- */
  return (
    <ListItem
      style={{ marginTop: "1%", alignItems: "flex-start", padding: "0%" }}
    >
      <ListItemText
        primary="Si coincide con RegExp →"
        secondary={
          <Grid container alignItems="center" spacing={8}>
            <Grid item xs={4}>
              <TextField
                placeholder="^[A-Z]"
                value={entrada || ""}
                onChange={handleEntradaChange}
                label="Expresión regular"
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={6}>
              {suggestions.length > 0 ? (
                <LabeledAutocomplete
                  label="Elementos"
                  isDisabled={false}
                  noOptionsMessage={() => "No se encontraron elementos"}
                  placeholder="Seleccione un elemento"
                  suggestions={suggestions}
                  value={salida}
                  onChange={handleSalidaChange}
                />
              ) : (
                <TextField
                  placeholder="Segmento 1"
                  value={salida || ""}
                  onChange={handleSalidaInputChange}
                  label="Salida"
                  style={{ width: "100%" }}
                />
              )}
            </Grid>
            <Grid item xs={2}>
              <IconButton aria-label="Borrar" onClick={handleRemove}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        }
      />
    </ListItem>
  );
});
